import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CopyToClipboard, FieldSelect, FieldWrapper, FlexBox, FormField, FormGrid, Icon, Page, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { analytics } from 'app/utils/segment';
import { AppLink } from 'components/appLink';
import { CodeHighlight } from 'components/codeHighlight';
import { withWidgets } from 'hocs';
import { useCopyWithDelay } from 'hooks/useCopyWithDelay';
import { useNotifications } from 'hooks/useNotifications';
import chatWidgetRawHTMLScript from './Snippet.html';
const TEMPLATE_OPTIONS = [
    { id: '{{agent_firstname}}', name: 'First Name' },
    { id: '{{agent_lastname}}', name: 'Last Name' },
    { id: '{{agent_displayname}}', name: 'Display Name' },
];
const ChatWidgetSettingsImpl = (props) => {
    var _a;
    const notify = useNotifications();
    const params = useParams();
    const [widget, setWidget] = useState(null);
    const { isCopied, setIsCopied } = useCopyWithDelay(false);
    useMount(() => {
        const { widgets } = props;
        const { chatWidgetId } = params;
        if (chatWidgetId) {
            widgets
                .getItem(chatWidgetId)
                .then((res) => {
                setWidget(res.data);
            })
                .catch(() => {
                notify({
                    title: 'An error occurred',
                    text: `An error occurred when trying to fetch widget`,
                    icon: 'exclamation',
                    className: 'danger',
                });
            });
        }
    });
    const updateWidget = (agentNameTemplate) => {
        const { widgets } = props;
        if (widget && agentNameTemplate) {
            const { id, name } = widget;
            widgets
                .update(id, {
                updates: {
                    agent_name_template: agentNameTemplate,
                },
            })
                .then(() => {
                notify({
                    title: `Widget ${name}`,
                    text: `"${name}" widget has been updated`,
                    icon: 'done',
                    className: 'success',
                    time: 5000,
                });
            })
                .catch(() => {
                notify({
                    title: 'An error occurred',
                    text: `An error occurred when trying to update the "${name}" widget`,
                    icon: 'exclamation',
                    className: 'danger',
                });
            });
        }
    };
    const copyCodeSnippet = () => {
        analytics.copyScript();
        setIsCopied(true);
    };
    const getCodeSnippet = (html = '') => {
        return { __html: widget ? html.replace('%WIDGET_ID%', widget.id) : '' };
    };
    const chatWidgetScript = getCodeSnippet(chatWidgetRawHTMLScript);
    const agentNameTemplate = (_a = widget === null || widget === void 0 ? void 0 : widget.agent_name_template) !== null && _a !== void 0 ? _a : '{{agent_displayname}}';
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [_jsx(AppLink, Object.assign({ path: "/settings/chat", style: { color: 'inherit' } }, { children: "Chat" })), _jsx(Icon, { name: "angle-right" }), `Setup${widget && ` - ${widget.name}`}`] })) }), _jsx(Page.Body, { children: _jsx(Page.Section, { children: _jsxs(FormGrid, { children: [_jsx(FormField, { children: _jsx(FieldSelect, { meta: {}, input: {
                                        name: 'agentNameTemplate',
                                        onChange: updateWidget,
                                        value: agentNameTemplate,
                                    }, label: "What agent name should be displayed to users in this chat widget?", items: TEMPLATE_OPTIONS }) }), _jsx(FormField, { children: _jsx(FieldWrapper, Object.assign({ label: "Place this script in to your website's HTML source code", helpIcon: {
                                        text: 'This code must be inserted into the section of every single page on which you wish to display the Dixa widget.',
                                        dark: true,
                                    }, noAlert: true }, { children: _jsx(CodeHighlight, Object.assign({ languages: ['html', 'js'], className: "js-snippit-highlight" }, { children: chatWidgetScript.__html })) })) }), _jsx(CopyToClipboard, Object.assign({ onClick: copyCodeSnippet, textToCopy: chatWidgetScript.__html, tooltip: false }, { children: _jsx(Button, { children: isCopied ? 'Copied' : 'Copy script' }) }))] }) }) })] }));
};
export const ChatWidgetSettings = withWidgets(ChatWidgetSettingsImpl);
